import Navigation from '../components/Navigation'
import Footer from '../components/Footer'
// import NewsBanner from '../components/Banners/NewsBanner'
import GridCarousel from '../components/Caroussels/GridCarousel'
import FactsCaroussel from '../components/Caroussels/FactsCaroussel'
// import MoreBanner from '../components/Banners/MoreBanner'
// import { Link } from 'react-router-dom'
import { footerEn /* footerAr*/ } from '../data/footer'
// import { HeaderBanner } from '../data/banner'
// import BannerHero from '../components/Banners/BannerHero'
// import {BannerData} from "../data/BannerData";


// import axios from 'axios'
import { Component } from 'react'

import { navigationTop, navigationButtom } from '../params'
import NewsBlockList from '../components/NewsBlockList'
// import UpcomingBlock from '../components/UpcomingBlock'


const grid = {
  title: 'HBKU Research Today',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis iaculis magna sit amet scelerisque venenatis. Nullam elementum felis vel metus dignissim mollis.',
    items: [
      {
        tag: [
          { classN: '', text: 'Partners' },
          // { classN: 'light', text: 'Press release' },
        ],
        image: 'https://www.hbku.edu.qa/sites/default/files/news/image3_4.jpg',
        title: 'HBKU and LCI-Qatar Support Lean Transformation of Construction Industry',
        description:"Joint MoU advances efforts towards sustainability in Qatar’s built environment",
        url:'https://www.hbku.edu.qa/en/news/HBKU-OTHER-LCISLTCI',
    
      },
      {
        tag: [
          { classN: '', text: 'Excellence' },
          // { classN: 'light', text: 'Press release' },
        ],
        image: 'https://www.hbku.edu.qa/sites/default/files/news/image1_174.jpg',
        title: 'Qatar Environment and Energy Research Institute Achieves ISO Accreditation for Calibration and Testing Laboratories',
        description:"QEERI upholds global standards as national RDI institution tackling Qatar’s water, energy, and environment challenges",
        url:'https://www.hbku.edu.qa/en/news/QEERI-SUST-ISOACTL',
    
      },
      {
        tag: [
          { classN: '', text: 'Innovation' },
          // { classN: 'light', text: 'Press release' },
        ],
        image: 'https://www.hbku.edu.qa/sites/default/files/news/image1_175.jpg',
        title: 'Middle School Seniors Become Technology Creators at Qatar Computing Research Institute’s Creative Space Summer Camp',
        description:"Qatar Computing Research Institute (QCRI), part of Hamad Bin Khalifa University (HBKU), welcomed enthusiastic middle school seniors from across Qatar to its annual Creative Space Summer Camp, which commenced on August 8. ",
        url:'https://www.hbku.edu.qa/en/news/QCRI-PE-MSSBTC',
    
      },
      {
        tag: [
          { classN: '', text: 'Press Releases' },
          // { classN: 'light', text: 'Press release' },
        ],
        image: 'https://www.hbku.edu.qa/sites/default/files/styles/event_detail_482x335/public/news/image1_239.jpg',
        title: 'HBKU Research Day Highlights Impact and Excellence',
        description:"HBKU showcases faculty and student research accomplishments",
        url:'https://www.hbku.edu.qa/en/news/HBKU-ACRS-RDHIAE',
    
      },
      {
        tag: [
          { classN: '', text: 'Excellence' },
          // { classN: 'light', text: 'Press release' },
        ],
        image: 'https://www.hbku.edu.qa/sites/default/files/styles/event_detail_482x335/public/news/image1_11_1.jpg',
        title: 'CSE Awarded Grant to Create a National Risk Management Plan for Qatar',
        description:"QAR 16.1 million QNRF grant will enable HBKU and international partners to strengthen the risk-resilience-sustainability nexus.",
        url:'https://www.hbku.edu.qa/en/news/CSE-ST-AGCNRMPQ',
      },
      
    ],
}

const events = {
  title: 'Upcoming Research Activities',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce dolor sapien, sodales vehicula leo et, elementum vulputate sapien. Nulla lacinia vehicula dapibus.',

    items: [
          
      {
        day: '21',
        mounth: 'NOV',
        name: 'Thematic Research Highlights',
        description: 'The Office of the Vice President for Research (OVPR) is pleased to invite you to attend the first of a series of sessions that will showcase HBKU’s on-going thematic research.',
        tag: 'Event',
        image: '/uploads/event-bg-ph.jpg',
        url: 'https://www.hbku.edu.qa/en/academic-events/OVPR-TRH',
      },
      {
        day: "24",
        mounth: 'NOV',
        name: 'Applications of KREX and Orvar Technologies for Autoantibody-based Biomarker Discovery',
        description: "Using conventional methods, it would be necessary to screen every single human protein, splice variant, neoantigen or microbial antigen to discover the total repertoire of autoantigens within a disease. ",        
        tag: 'Webinar',
        image: '/uploads/event-bg-ph.jpg',
        url: 'https://www.hbku.edu.qa/en/academic-events/QBRI-PM-AKREXOTA',
      },
      {
        day: "29 - 01",
        mounth: 'Nov-Dec',
        name: 'The First Advances in Precision Medicine (APM2021) Conference',
        description: "The first Advances in Precision Medicine (APM2021) conference will focus on “Epigenetics and Precision Medicine” to highlight exciting recent developments in the field of epigenetics related to clinical decision making, diagnosis, and treatment.",        
        tag: 'Conference / Precision Medicine',
        image: '/uploads/event-bg-ph.jpg',
        url: 'https://www.hbku.edu.qa/en/APM21',
      },
     {
        day: '29 - 31',
        mounth: 'Mar 2022',
        name: 'The 17th International Conference on Persuasive Technology 2022',
        description: "Persuasive Technology (PT) is a vibrant interdisciplinary research field focusing on the design, development, and evaluation of interactive technologies. PT aims at changing people’s attitudes or behaviors through persuasion and social influence, ",
        tag: 'Workshop - Social Sciences',
        image: '/uploads/event-bg-ph.jpg',
        url: 'https://www.hbku.edu.qa/en/academic-events/CSE-SUST-ICPT22',
      },
      {
        day: "08",
        mounth: 'Apr',
        name: 'Parkinson’s Disease: Early Clinical Diagnosis, Red Flags and Treatment.',
        description: "Parkinson's disease (PD) is a neurodegenerative disease that usually affects older people. The disease affects a part of the brain that controls movement called the substantia nigra. The dead cells in this part no longer produce an important chemical called dopamine.",        
        tag: 'Parkinson / Webinar',
        image: '/uploads/event-bg-ph.jpg',
        url: 'https://www.hbku.edu.qa/en/academic-events/parkinson-disease-treatment',
      },
        
  ]
}

const crumb = [
  { link: '/', text: 'Home' },
  { link: '/research', text: 'Research' },
]

class EventsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading : false,
      page: 0,
      id: null,
      title: 'Home',
      body: '',
      welcomeMessage: null,
      focusAreas: null,
      quickLinks: null,
      items: [],
      DataisLoaded: false
    }
  }
  componentDidMount() {
    this.loadMore();
}
  componentDidUpdate() {
    document.title = `${this.state.title} - HBKU`
  }

  loadMore(){
    if(this.state.isLoading){
      return
    }
    this.setState({
      ...this.state,
      isLoading: true
    })
    fetch(
      "https://www.hbku.edu.qa/en/api/ri-news.json?field_news_category_tid=2678&language=en&page="+this.state.page)
              .then((res) => res.json())
      
              .then((json) => {
                  const updatedData = json.map((item) => {
                    return {
                      tag: item?.news_category?.map(cat=>({
                        class: '',
                        text: cat
                      })),
                      image: item?.Image,
                      title: item?.title,
                      description: item?.summary,
                      url:'https://www.hbku.edu.qa/en/node/'+ item?.nid,
                    }
                  });
                  this.setState({
                      ...this.state,
                      items: [...this.state.items,...updatedData],
                      DataisLoaded: true,
                      page : updatedData?.length ? this.state.page + 1 : this.state.page ,
                      isLoading :false,
                  });
              })
  }

  // componentDidMount() {
  //   axios
  //     .get('/research/caa14df2-2019-4955-a8fc-dbfd1a4b18f7')
  //     .then(res => {
  //       const attributes = res.data.data.attributes
  //       const relationships = res.data.data.relationships
  //       let state = {
  //         id: res.data.data.id,
  //         title: attributes.title,
  //         body: attributes.body.processed,
  //         welcomeMessage: relationships.field_official_message.links.related.href,
  //         focusAreas: relationships.field_thematic_focus_areas.links.related.href,
  //         quickLinks: relationships.field_quick_links.links.related.href,
  //       }

  //       this.setState(state)
  //     })
  //     .catch(err => console.log(err))
  // }

  render() {
    const { DataisLoaded, items } = this.state;
    const headerData = {
      title: 'Research at HBKU',
      crumb: crumb,
      navigationButtom: navigationButtom,
      navigationTop: navigationTop,
      applicationLinks: [{ text: 'Apply now', class: 'bordred', link: 'https://hbkuqa.elluciancrmrecruit.com/Apply/Account/Login?ReturnUrl=%2fApply' }],
    }

    const navigationIntern = [
      { text: 'Latest News', hash: '#news', isActive: true },
      { text: 'Upcoming Research Activities', hash: '#events', isActive: false },
    ]

    return (
      <>
        <Navigation
          {...headerData}
          navigationIntern={navigationIntern}
          updateLang={this.props.updateLang}
        />

       {/* {items.map((item) => (<div>
          this is item {item.title}
       </div>)  )} */}
       <section className="m-wrap">
        <div className='container'>
          <div className='row'>
            <div className="col-12">
              <div className="t-block">
									<div className="t-block__content ">
                  {items.map((data) => (
                    <NewsBlockList data={data} />
                  ))}
									</div>
								</div>
                {this.state.isLoading ? (<div>loader goes here</div> ): null}
                <div className='text-center'><button  onClick={()=>this.loadMore()} className='action'>Load more</button></div>
            </div>
          </div>
        </div>
      </section>

      
       
        {/* <FactsCaroussel
          {...events}
          parentId={this.state.id}
          subtitle=''
          title='Upcoming Research Activities'
          itemId='events'
        /> */}
        {/* <UpcomingBlock 
       title={'Featured Stories - Block'}
       desc={'It will launch in the phase -2'}
       isPhase2={true}
       /> */}
        
        <Footer {...footerEn} />
      </>
    )
  }
}

export default EventsPage
